export default __webpack_public_path__ + "static/media/DefaultLogo.753b9621.png";